import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  impactsLibraryButton: {
    '&&': {
      minWidth: 150,
      maxHeight: 40,
      marginRight: 'auto',

      boxShadow: `2px 4px 8px ${theme.palette.custom.grey}`,
      borderRadius: 20,

      fontSize: FONTS.SIZES.s,
      fontWeight: FONTS.WEIGHTS.bold,
      // color: theme.palette.custom.white,
    },
  },
  button: {
    border: `1px solid ${theme.palette.custom.grey3}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
    width: 40,
    borderRadius: '50%',
    cursor: 'pointer',
    '&&:hover': {
      border: `1px solid ${theme.palette.custom.darkBlue2}`,
    },

    '&&:active': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  selectImpactButton: {
    '&&': {
      minWidth: '85px',
      alignSelf: 'center',
    },
  },
  buttonMb: {
    '&&': {
      marginBottom: SPACES.xxl,
    },
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACES.m,
  },
  modalWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',

      overflowY: 'overlay',

      [theme.breakpoints.down('tablet')]: {
        width: 'calc(100vw - 40px)',
        height: 600,
        maxHeight: 'calc(100vh - 100px)',

        padding: SPACES.l,
        gap: SPACES.xl,
      },
      [theme.breakpoints.up('tablet')]: {
        padding: SPACES.xxxxl,
        height: 800,
        maxHeight: 'calc(100vh - 80px)',
        maxWidth: 'calc(100vw - 80px)',
      },

      scrollbarWidth: '6px',
      scrollbarColor: theme.palette.custom.grey2,
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        background: theme.palette.custom.grey2,
        borderRadius: '10px',
      },
    },
  },
  upperWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      gap: SPACES.xl,
      width: '100%',
    },
  },
  modalTitle: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      color: theme.palette.custom.darkBlue2,

      [theme.breakpoints.down('tablet')]: {
        fontSize: FONTS.SIZES.xl,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.xxxl,
      },
    },
  },
  paginationButtonWrapper: {
    '&&': {
      display: 'flex',
      alignSelf: 'flex-end',

      [theme.breakpoints.down('tablet')]: {
        gap: SPACES.xxxs,
      },
      [theme.breakpoints.up('tablet')]: {
        gap: SPACES.xs,
      },
    },
  },
  paginationButton: {
    '&&': {
      borderRadius: '17.5px',
      width: 50,
      height: 35,

      '&:disabled': {
        backgroundColor: theme.palette.custom.grey,
        color: theme.palette.custom.primary,
      },
    },
  },
  itemsListWrapper: {
    '&&': {
      display: 'inline-flex',
      width: '100%',

      [theme.breakpoints.down('tablet')]: {
        rowGap: SPACES.s,
        columnGap: SPACES.s,

        justifyContent: 'center',
      },
      [theme.breakpoints.up('tablet')]: {
        rowGap: '2.5rem',
        columnGap: SPACES.xxxxxl,
      },
    },
  },
  itemWrapper: {
    '&&': {
      paddingRight: SPACES.s,

      backgroundColor: theme.palette.custom.white,
      border: `1px solid ${theme.palette.custom.grey}`,
      borderRadius: '10px',
      boxShadow: 'none',

      [theme.breakpoints.down('tablet')]: {
        width: 'calc(100vw - 80px)',
        height: 'auto',
        minHeight: 70,

        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: SPACES.xs,
      },
    },
  },
  itemImage: {
    '&&': {
      width: 70,
      height: 70,
    },
  },
  itemContent: {
    '&&': {
      width: '100%',
      color: theme.palette.custom.darkBlue2,

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  itemText: {
    display: 'flex',
    flexDirection: 'column',
  },
  itemName: {
    '&&': {
      marginRight: SPACES.xxxs,

      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.35,
      color: 'inherit',

      wordBreak: 'break-word',
    },
  },
  filterWrapper: {
    display: 'flex',
    gap: SPACES.s,
    flexWrap: 'wrap',
    alignItems: 'center',

    marginBottom: SPACES.s,
  },
  filterInner: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: SPACES.s,
    width: '100%',
  },
  filterSelect: {
    display: 'flex',
    gap: SPACES.s,
    flexWrap: 'wrap',
  },
  tableRow: {
    '&&': {
      '&:last-child td': {
        border: 0,
      },
      "& td:not([colspan='4'])": {
        border: 0,
      },
    },
  },
  rowUrlLink: {
    '&&': {
      fontSize: FONTS.SIZES.s,

      display: 'flex',
      alignItems: 'center',
      gap: SPACES.xxs,
    },
  },
  urlIcon: {
    width: 17,
    height: 17,
  },
  descriptionWrapper: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    overflowWrap: 'break-word',
  },
  selectionWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    marginLeft: 'auto',
    marginRight: 'auto',
    justifyContent: 'center',
    minWidth: 70,
  },
  suggestionModal: {
    height: 300,
    width: 400,

    [theme.breakpoints.down('tablet')]: {
      maxWidth: 'calc(100vw - 40px)',
      maxHeight: 'calc(100vh - 100px)',

      padding: `${SPACES.xxxxxxl} ${SPACES.l} ${SPACES.l} ${SPACES.l}`,
    },
    [theme.breakpoints.up('tablet')]: {
      padding: `${SPACES.xxxxxxl} ${SPACES.xxxxl} ${SPACES.xxxxl} ${SPACES.xxxxl}`,
      maxWidth: 'calc(100vw - 80px)',
    },
  },
  suggestionForm: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: SPACES.xl,
  },
  suggestButtonWrapper: {
    flex: 1,
    display: 'flex',
    justifyContent: 'end',

    [theme.breakpoints.down('tablet_s')]: {
      justifyContent: 'center',
    },
  },
}))
